var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00318 2.6665C8.73796 2.6665 8.48361 2.77186 8.29607 2.9594C8.10853 3.14693 8.00318 3.40129 8.00318 3.6665C8.00318 3.93172 8.10853 4.18607 8.29607 4.37361C8.48361 4.56115 8.73796 4.6665 9.00318 4.6665C9.26839 4.6665 9.52275 4.56115 9.71028 4.37361C9.89782 4.18607 10.0032 3.93172 10.0032 3.6665C10.0032 3.40129 9.89782 3.14693 9.71028 2.9594C9.52275 2.77186 9.26839 2.6665 9.00318 2.6665ZM8.76318 5.8465C7.96984 5.91317 5.80318 7.63984 5.80318 7.63984C5.66984 7.73984 5.70984 7.73317 5.81651 7.91984C5.92318 8.09984 5.90984 8.11317 6.03651 8.0265C6.16984 7.93984 6.38984 7.79984 6.75651 7.57317C8.16984 6.6665 6.98318 8.75984 6.37651 12.2865C6.13651 14.0332 7.70984 13.1332 8.11651 12.8665C8.51651 12.6065 9.58984 11.8665 9.69651 11.7932C9.84318 11.6932 9.73651 11.6132 9.62318 11.4465C9.54318 11.3332 9.46318 11.4132 9.46318 11.4132C9.02984 11.6998 8.23651 12.2998 8.12984 11.9198C8.00318 11.5398 8.81651 8.93317 9.26318 7.13984C9.33651 6.71317 9.53651 5.77984 8.76318 5.8465Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI);
export default __webpack_public_path__ + "static/media/i.b41df81dab3a2bb833af9f8f749add3e.svg";
export { ForwardRef as ReactComponent };